import { Component, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";

export interface UnsavedChangesDialogData {
  dirtySections: string[];
}

export type UnsavedChangesAction = "save" | "discard" | "cancel";

@Component({
    selector: "app-unsaved-changes-dialog",
    templateUrl: "./unsaved-changes-dialog.component.html",
    styleUrls: ["./unsaved-changes-dialog.component.scss"],
    standalone: false
})
export class UnsavedChangesDialogComponent {
  constructor(
    public dialogRef: VngDialogRef<UnsavedChangesDialogComponent>,
    @Inject(VNG_DIALOG_DATA) public data: UnsavedChangesDialogData
  ) {}

  onSave(): void {
    this.dialogRef.close("save" as UnsavedChangesAction);
  }

  onDiscard(): void {
    this.dialogRef.close("discard" as UnsavedChangesAction);
  }

  onCancel(): void {
    this.dialogRef.close("cancel" as UnsavedChangesAction);
  }
}
